<template>
  <div class="categorias-overlay">
    <div class="categorias-modal">
      <!-- Botón cerrar -->
      <button
        type="button"
        class="categorias-modal__close"
        @click="$emit('cerrar')"
      >
        ✕
      </button>

      <!-- Header -->
      <div class="categorias-modal__header">
        <h2 class="categorias-modal__title">Gestión de categorías</h2>
        <p class="categorias-modal__subtitle">
          Crea, edita y organiza las categorías que se usarán para clasificar los productos.
        </p>
      </div>

      <!-- Contenido principal: formulario + lista -->
      <div class="categorias-modal__content">
        <!-- Columna izquierda: formulario -->
        <div class="categorias-modal__col categorias-modal__col--form">
          <div class="categorias-modal__section-card">
            <h3 class="categorias-section__title">Nueva categoría</h3>
            <p class="categorias-section__subtitle">
              Define un nombre y, si lo necesitas, un identificador interno.
            </p>

            <FormularioCategoria
              @categoriaAgregada="actualizarLista"
              @finalizarCreacionCategoria="$emit('finalizarCreacionCategoria')"
            />
          </div>
        </div>

        <!-- Columna derecha: lista -->
        <div class="categorias-modal__col categorias-modal__col--list">
          <div class="categorias-modal__section-card categorias-modal__section-card--list">
            <h3 class="categorias-section__title">Categorías existentes</h3>
            <p class="categorias-section__subtitle">
              Visualiza las categorías disponibles. Los cambios se reflejan en los filtros y productos.
            </p>

            <div class="categorias-list-wrapper">
              <ListaCategorias :categorias="categorias" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormularioCategoria from './FormularioCategoria.vue';
import ListaCategorias from './ListaCategorias.vue';
import axios from 'axios';

export default {
  name: 'GestionCategorias',
  components: {
    FormularioCategoria,
    ListaCategorias,
  },
  data() {
    return {
      categorias: [],
    };
  },
  mounted() {
    this.actualizarLista();
  },
  methods: {
    async actualizarLista() {
      try {
        const res = await axios.get('/api/almacen/categorias/listar');
        this.categorias = Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        console.error('Error al cargar categorías', error);
        this.$toast?.error('No se pudieron cargar las categorías.');
      }
    },
  },
};
</script>


<style scoped lang="scss">
.categorias-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.3),
      rgba(15, 23, 42, 0.98)
    );
  backdrop-filter: blur(18px);
}

/* Modal principal */
.categorias-modal {
  position: relative;
  width: 100%;
  max-width: 960px;
  border-radius: 1.6rem;
  padding: 1.4rem 1.35rem 1.25rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.97)
    );
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow:
    0 22px 60px rgba(15, 23, 42, 0.95),
    0 0 0 1px rgba(15, 23, 42, 0.9);
  color: #e5e7eb;
}

/* Cerrar */
.categorias-modal__close {
  position: absolute;
  top: 0.6rem;
  right: 0.8rem;
  border: none;
  background: transparent;
  color: #cbd5f5;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.2rem;
}

/* Header */
.categorias-modal__header {
  margin-bottom: 0.9rem;
}

.categorias-modal__title {
  font-size: 1rem;
  font-weight: 600;
  color: #f9fafb;
}

.categorias-modal__subtitle {
  margin-top: 0.2rem;
  font-size: 0.8rem;
  color: #94a3b8;
}

/* Layout contenido */
.categorias-modal__content {
  display: flex;
  gap: 0.9rem;
  margin-top: 0.4rem;
  align-items: flex-start;
}

.categorias-modal__col {
  min-width: 0;
}

.categorias-modal__col--form {
  flex: 0 0 45%;
}

.categorias-modal__col--list {
  flex: 1 1 auto;
}

/* Tarjetas internas */
.categorias-modal__section-card {
  border-radius: 1.15rem;
  padding: 0.8rem 0.8rem 0.7rem;
  background: rgba(15, 23, 42, 0.94);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.9);
}

.categorias-modal__section-card--list {
  min-height: 180px;
}

/* Titulitos de secciones */
.categorias-section__title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #e5e7eb;
}

.categorias-section__subtitle {
  margin-top: 0.15rem;
  font-size: 0.78rem;
  color: #9ca3af;
}

/* Lista scrollable */
.categorias-list-wrapper {
  margin-top: 0.55rem;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 0.2rem;
}

/* Scroll pequeño y discreto */
.categorias-list-wrapper::-webkit-scrollbar {
  width: 6px;
}

.categorias-list-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.categorias-list-wrapper::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.7);
  border-radius: 999px;
}

/* Responsive */
@media (max-width: 768px) {
  .categorias-modal {
    padding: 1.1rem 1rem 1rem;
    border-radius: 1.3rem;
  }

  .categorias-modal__content {
    flex-direction: column;
    gap: 0.75rem;
  }

  .categorias-modal__col--form,
  .categorias-modal__col--list {
    flex: 1 1 auto;
  }

  .categorias-list-wrapper {
    max-height: 260px;
  }
}
</style>
